export default __webpack_public_path__ + "static/media/success.c0e7fdda.svg";